import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "The Vow",
    body:
      "Dark fantasy character songs for D&D players, fantasy fans, and the ones who survived the story.",
  },
  {
    num: "02",
    title: "The Cost",
    body: "Every song is a confession. Every oath has a cost.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 },
  }),
};

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto-section"
      className="relative mx-auto max-w-6xl px-6 py-28 sm:py-40"
    >
      {/* Section heading */}
      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        custom={0}
        className="mb-20 max-w-3xl sm:mb-28"
      >
        <p className="font-accent mb-6 text-[0.62rem] uppercase tracking-[0.45em] text-[#c9a227]">
          The Confession
        </p>
        <h2
          data-testid="manifesto-headline"
          className="font-serif-display text-4xl leading-[1.02] tracking-tight text-[#e8e3d2] sm:text-6xl lg:text-7xl"
        >
          Stream Medieval Confessions{" "}
          <span className="italic text-[#b8a679]">Everywhere</span>.
        </h2>
      </motion.div>

      {/* Numbered chapters */}
      <div className="grid gap-px overflow-hidden border-y border-white/10 bg-white/[0.04] sm:grid-cols-2">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.num}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            custom={i + 1}
            data-testid={`manifesto-chapter-${c.num}`}
            className="group relative bg-[#050505] p-8 sm:p-12"
          >
            <div className="mb-8 flex items-baseline gap-4">
              <span className="font-accent text-sm tracking-[0.3em] text-[#c9a227]">
                {c.num}
              </span>
              <span className="h-px flex-1 bg-white/10 transition-colors duration-500 group-hover:bg-[#c9a227]/40" />
              <span className="font-accent text-[0.6rem] uppercase tracking-[0.3em] text-[#a39e8f]">
                {c.title}
              </span>
            </div>
            <p className="font-serif-display text-2xl leading-snug text-[#e8e3d2] sm:text-3xl">
              {c.body}
            </p>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default Manifesto;
